import React, {useEffect, useState} from "react";
import MangeDashboard from "./MangeDashboard";
import axios from "axios";
import './ListStyle.css'
import { toast } from "react-toastify";
import moment from "jalali-moment";

export function ListVariz(){
  const [list,setList] = useState([])
  const [isLoading,setIsLoading] = useState(true)

  let phone = sessionStorage.getItem('user')
  useEffect(()=>{

    axios.get('https://api.sinatether.com/Auth/PaymentVerify/',{
      params:{phone},
      withCredentials:true
    }).then((res)=>{
        console.log(res)
        if (res.data['status'] == 200){
             setList(res.data['ListVariz'])
             setIsLoading(false)

        }
    }).catch((error)=>{
        if(error){
            if (error.response.status === 400){
                toast.dismiss()
                toast.error("نشست شما منقضی شده است مجددا وارد شوید")
            }
        }
    })


  },[])


   function handelClick(){
             document.getElementById('fa-refresh').classList.add('fa-spin');
             setTimeout(function (){
                 document.getElementById('fa-refresh').classList.remove('fa-spin');


       },2000)



      axios.get('https://api.sinatether.com/Auth/PaymentVerify/',{
      params:{phone},
      withCredentials:true
    }).then((res)=>{
        console.log(res)
        if (res.data['status'] == 200){
             setList(res.data['ListVariz'])
             setIsLoading(false)


        }
    }).catch((error)=>{
       if(error){
        if (error.response.status === 401){
            toast.dismiss()
            toast.error("نشست شما منقضی شده است مجددا وارد شوید")
        }

       }
    })
   }


    return(
        <>

          <MangeDashboard>


                                      




                                          
                  <div className={'list-report'}>
    <div className={''}>
            <div className={'plr-12'}>

            <div className={'head_29540 padd-title text-center '}>
                <div className="text-title-report">
                    تاریخچه واریز وجه تومانی

                </div>

            </div>


                    <div className={'listContent__29514'}>
                        <div className="tableHeader__29540 bt-0">
                            <div className={'col-4 text-normal pl-0 '}>تاریخ</div>
                            <div className={'col-4 text-normal '}>مبلغ</div>
                            <div className={'col-4 text-normal '}>شماره کارت</div>



                        </div>
                        {isLoading ?
                            <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>

                                <i className="fa fa-spinner fa-spin loadIcon"></i>


                            </div>
                            :


                            <div className={'listcoinTable '}>
                               
                                 {list ? list.map((li) => (
                                    <>


                                        <div className={'row itemCoins titem2020 '} name={'n'}
                                        >

                                            <div className={'col-4 '}>

                                            <span
                                                className={'text-normal text-content d-grid'}>

                                                

                                                <span className={' mynumber text-content mynorm-text '}>
                                                {moment(li.date.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}                                               </span>
                                                <span  className=" mynumber  text-content mynorm-text ">{li.date.split('T')[1]}</span>                                          

                                            </span>


                                            </div>
                                            <div className={'col-4   '}>
                                            <span className={' text-content mynumber mynorm-text d-flex lineheight-40 '}>
                                                {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(li['amount'])}

                                                <div className="text-normal text-content">
                                                    تومان
                                                </div>
                                            </span>
                                            </div>

                                            <div className={'col-4  '}>
                                            <span className={'mynorm-text mynumber text-content lineheight-40 '}>
                                               {li.cart_number}
                                                                                                                                 </span>
                                            </div>
                                           



                                        </div>

                                        {li['transaction_id'] & li['transaction_id'] != 'در انتظار' ?
                                        

                                        <div className="row mt-2 pr-2">
                                            <div className="col-4">
                                                <span className="text-normal text-content">شماره پیگیری</span>

                                            </div>

                                            <div className="col-8">
                                                <span className="text-normal text-content">{li['transId']}</span>
                                            </div>


                                        </div>
                                        :
                                        <></>
                                        }

                                         


                                       
                                        
                            
                                    
                                        
                                        




                                        </>


                                    ))

                                    :

                                    <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>
                                        <span className={'text-muted text-normal text-content'}>هیچ واریزی ثبت نشده</span>

                                    </div>


                                }


                            </div>
                        }


                    </div>
                    

                




        </div>


</div>
        </div>









          </MangeDashboard>




        </>
    )
}